import deepMerge from 'deepmerge';

import countrySpecificRules from '@config/countrySpecificRules';
import { RULE_SECTIONS } from '@constants/config';

/**
 * Custom array merge function for deepMerge that will always return the sourceArray to prevent array merging
 * @param {Array} destinationArray
 * @param {Array} sourceArray
 * @returns {Array} sourceArray
 */
const overwriteArrayMerge = (destinationArray, sourceArray) => sourceArray;

/**
 * Returns a rule set for a country, made up of a combination of default rules and country specific overwrites.
 * @param {string} [country='default'] Two letter country code or 'default'
 * @param {string} [section] Optional param to retrieve only a specific section of rules
 * @returns {Object} Rule set
 */
export const getCountrySpecificRules = (country = RULE_SECTIONS.DEFAULT, section) => {
  const countryIso = country.toUpperCase();

  const defaultRules = section
    ? countrySpecificRules.default?.[section]
    : countrySpecificRules.default;

  const countryRules = section
    ? countrySpecificRules?.[countryIso]?.[section]
    : countrySpecificRules?.[countryIso];

  if (countryIso === RULE_SECTIONS.DEFAULT.toUpperCase()) return defaultRules;

  if (typeof defaultRules === 'boolean' || typeof countryRules === 'boolean') {
    return countryRules ?? defaultRules;
  }

  return deepMerge(defaultRules || {}, countryRules || {}, { arrayMerge: overwriteArrayMerge });
};
